import { Box, Typography } from '@mui/material';
import { Product } from 'model/deals.model';
import { useEffect, useState } from 'react';
import { ClientService } from '../../../../../service/client.service';
import zeplinColor from '../../../../../theme/Color';
import AddProductCard from './AddProductCard';

const AddProductFormField = ({
  handleInputChange,
  value,
  opportunityId,
  pricebookName,
}: {
  handleInputChange: (field: string, value: any) => void;
  opportunityId: string;
  pricebookName: string;
  value: any;
}) => {
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const getPricebookProducts = async () => {
    try {
      setLoading(true);
      const res = await ClientService.getPricebookProducts(value?.pricebook2Id);

      setProducts(res.products);

      const productEntries = res.products.map((product: Product) => ({
        OpportunityId: opportunityId || '',
        PricebookEntryId: product?.PricebookEntryId,
        Quantity: '',
        UnitPrice: product?.UnitPrice,
      }));

      handleInputChange('products', productEntries);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!value?.products && !value?.products?.length) {
      value?.pricebook2Id && getPricebookProducts();
    } else {
      setProducts(value?.products?.length ? [...value?.products] : []);
    }
  }, []);

  return (
    <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
        <Typography variant='heading4'>Add Products</Typography>
        <Typography variant='body2' color={zeplinColor.Neutral9}>
          Price book: {pricebookName} Price Book
        </Typography>
        {loading === true
          ? [1, 2, 3, 4].map((val) => (
              <AddProductCard index={val} handleInputChange={handleInputChange} />
            ))
          : ''}
        {products?.length
          ? products?.map((val, index) => (
              <AddProductCard data={val} index={index} handleInputChange={handleInputChange} />
            ))
          : ''}
      </Box>
    </Box>
  );
};

export default AddProductFormField;
